import React from "react";
import { Svg } from "../../../../Shared/Assets/Svg/React";
import {
  Button,
  ButtonColor,
  ButtonSize,
  ButtonType
} from "../../../../Shared/Buttons/React";
import { Modal } from "../../../../Shared/Modal/React";
import { useTranslationContext } from "../../context/translationContext";

interface ProvetConfirmCloseModalProps {
  active: boolean;
  onConfirmClose: () => void;
  onCancel: () => void;
}

/**
 * Modal that asks for confirmation when the user tries to close the summary modal.
 * Warns that closing will discard the booking in progress.
 */
export const ProvetConfirmCloseModal = ({
  active,
  onConfirmClose,
  onCancel
}: ProvetConfirmCloseModalProps) => {
  const translationContext = useTranslationContext();
  const translations = translationContext?.translations;
  const titleId = "provet-confirm-close-modal-title";

  return (
    <Modal
      active={active}
      onClose={onCancel}
      hasFooter={true}
      titleId={titleId}
      modalName="confirmClose"
    >
      <div className="w-full p-xs text-t-neutral-600 md:w-[38.25rem] md:p-lg">
        {/* Header */}
        <div className="flex mb-md items-center font-guardian text-t-md sm:text-t-xl font-t-semi-bold leading-lg sm:leading-xxl">
          <h2
            id={titleId}
            className="flex items-center font-guardian text-dark-blue text-t-md sm:text-t-xl font-t-semi-bold leading-lg sm:leading-xxl gap-xs md:gap-sm"
          >
            <Svg
              href="/dist/sprite.svg#sys-info"
              additionalClass={"fill-t-neutral-700"}
            />
            {translations?.discardBookingConfirmationTitle}
          </h2>
        </div>
        {/* Message */}
        <div className="text-t-md font-normal leading-lg md:text-t-md md:leading-xxl">
          <span>{translations?.discardBookingConfirmationText}</span>
        </div>
      </div>
      {/* Action Buttons */}
      <div className="flex flex-col sticky z-[2] justify-center bottom-0">
        <div className="p-lg px-xs bg-white border-t border-neutral-200 md:px-2xl md:py-2xl">
          <div className="flex flex-col gap-md mt-2xl px-lg sm:flex-row md:mt-container-md">
            <Button
              type={ButtonType.Button}
              size={ButtonSize.LG}
              color={ButtonColor.DarkBlue}
              onClick={onCancel}
              data-online-booking-action="confirm"
            >
              {translations?.backToBooking}
            </Button>
            <Button
              type={ButtonType.Button}
              size={ButtonSize.LG}
              color={ButtonColor.Pink}
              onClick={onConfirmClose}
              data-online-booking-action="cancel"
            >
              {translations?.discardBooking}
            </Button>
          </div>
        </div>
      </div>
    </Modal>
  );
};
